import React from 'react';
import { Link } from 'react-router-dom';

const Cards = ({ content }) => {

  const cardMain = card => {
    if (card.cardMainTitle || card.cardMainDescription) {
      return (
        <div className="card-main-content">
          <img src={card.cardImg} className="card-image" alt={card.cardImg.split('/')[card.cardImg.split('/').length - 1]} />
          <div className="card-main-text-group">
            <h5 className="heading-5 card-main-title">{card.cardMainTitle}</h5>
            <p className="text-block-2 card-main-description">{card.cardMainDescription}</p>
          </div>
        </div>
      );
    } else {
      return <img src={card.cardImg} className="card-image" alt={card.cardImg.split('/')[card.cardImg.split('/').length - 1]} />;
    }
  };
  const cardHeaderTitleFlipper = (card, i) => {
    if (card.titleFlipper) {
      return (
        <div key={i} className="card-title-flipper-wrapper">
          <h3 className="card-title"> {card.title} </h3>
          <h3 className="card-title-flipper"> {card.titleFlipper} </h3>
        </div>
      );
    } else {
      return (
        <h3 key={i} className="card-title">
          {' '}
          {card.title}{' '}
        </h3>
      );
    }
  };
  const linkType = (card, i) => {
    if (card.type === 'external_link') {
      return (
        <a href={card.linkTo} target="_blank">
          {cardMain(card, i)}
          <div className="card-overlay">
            <div className="card-header">
              <svg className="card-arc" xmlns="http://www.w3.org/2000/svg">
                <path d="M 40 80 c 22 0 40 -22 40 -40 v 40 Z" />
              </svg>
              <img className="card-thumb" src={card.thumbImg} alt={card.thumbImg.split('/')[card.thumbImg.split('/').length - 1]} />
              {cardHeaderTitleFlipper(card)}
            </div>
            <p className="card-description text-block-2"> {card.desc} </p>
          </div>
        </a>
      );
    } else {
      return (
        <Link to={card.linkTo}>
          {cardMain(card, i)}
          <div className="card-overlay">
            <div className="card-header">
              <svg className="card-arc" xmlns="http://www.w3.org/2000/svg">
                <path d="M 40 80 c 22 0 40 -22 40 -40 v 40 Z" />
              </svg>
              <img className="card-thumb" src={card.thumbImg} alt={card.thumbImg.split('/')[card.thumbImg.split('/').length - 1]} />
              {cardHeaderTitleFlipper(card)}
            </div>
            <p className="card-description text-block-2"> {card.desc} </p>
          </div>
        </Link>
      );
    }
  };
  return (
    <div className="cards-wrapper">
      {content.map((card, i) => {
        return (
          <div key={i} className="card-item">
            {linkType(card,i)}
          </div>
        );
      })}
    </div>
  );
};

export default Cards;
